import { Module } from 'vuex'
import loginAuth from '@finance/login'
import { getClientInfo } from '@/utils/client'

const common: Module<any, any> = {
  state: {
    loading: false, // loading显示状态
    payToast: false, // 支付loading显示状态
    payToastText: '加载中', // loading显示状态
    containerClass: '', // container Class
    refreshBtnVisiable: false, // 是否展示点击刷新按钮，一般在接口出错的时候展示
    loginState: false, // 登录状态
    custodyState: false, // 是否开了存管户状态
    isFetchSilentLoginState: false, // 是否已经调用过静默登录的接口请求
    // unreadMessageCount: 0,
    clientInfo: null,
    profile: {}
  },
  getters: {
    phoneInfo(state) {
      if (state.clientInfo && state.clientInfo.phoneInfo) {
        return state.clientInfo.phoneInfo.result || {}
      }
      // return { UUID: 'androidId-135325d0f46ccf88', platform: 'Android' }
      return {}
    },
    userInfo(state) {
      if (state.clientInfo && state.clientInfo.userInfo) {
        return state.clientInfo.userInfo.result || {}
      }
      return {}
    },
    toolBarHeight(state) {
      if (state.clientInfo && state.clientInfo.phoneInfo) {
        const { toolBarHeight = 0 } = state.clientInfo.phoneInfo.result
        return Number(toolBarHeight) / window.devicePixelRatio
      }
      return 58
    },
  },
  mutations: {
    showLoading(state) {
      state.loading = true
    },
    hideLoading(state) {
      state.loading = false
    },
    showPayToast(state) {
      state.payToast = true
    },
    hidePayToast(state) {
      state.payToast = false
    },
    updatePayToastText(state, data) {
      state.payToastText = data
    },
    setContainerClass(state, containerClass) {
      state.containerClass = containerClass
    },
    showRefreshBtn(state) {
      state.refreshBtnVisiable = true
    },
    hideRefreshBtn(state) {
      state.refreshBtnVisiable = false
    },
    updateLoginState(state, payloay) {
      state.loginState = payloay
    },
    updateCustodyState(state, payloay) {
      state.custodyState = payloay
    },
    updateSilentLoginState(state) {
      state.isFetchSilentLoginState = true
    },
    // updateUnreadMessageCount(state, data) {
    //   state.unreadMessageCount = data
    // },
    updateClientInfo(state, data) {
      state.clientInfo = data
    },
    updatProfile(state, data) {
      state.profile = data
    }
  },
  actions: {
    // 静默登录
    slientLogin({ commit, state }, forceUpdate = true) {
      if (state.isFetchSilentLoginState && !forceUpdate) {
        return state.loginState ? Promise.resolve() : Promise.reject()
      }
      return new Promise((resolve, reject) => {
        loginAuth.login({
          type: loginAuth.loginTypes.silent,
          success: ({ isLogin = false, ...profile }) => {
            console.log('调用静默登录', isLogin)
            commit('updateSilentLoginState')
            commit('updateLoginState', isLogin)
            commit('updatProfile', profile)
            if (isLogin) {
              resolve(true)
            } else {
              reject()
            }
          },
          error: (err: any) => {
            console.warn('静默登录出错', err)
            reject()
          } // 登录失败的回调方法，会传出报错信息
        })
      })
    },
    getClientInfo({ commit, state }, forceUpdate = true) {
      if (state.clientInfo && !forceUpdate) {
        return state.clientInfo ? Promise.resolve() : Promise.reject()
      }
      return getClientInfo(['phoneInfo', 'userInfo'])
        .then((res: any) => {
          console.log('getClientInfo succes: ', res)
          commit('updateClientInfo', res)
        }).catch((err) => {
          console.warn('getClientInfo fail:', err)
        })
    }
  }
}

export default common
